import { render } from "./App.vue?vue&type=template&id=5a0be84a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5a0be84a&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-moose_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__